import { flatten as i } from "./ghl-ui.es932.js";
import { warn as n } from "./ghl-ui.es853.js";
function d(l, t = "default", r = void 0) {
  const e = l[t];
  if (!e)
    return n("getFirstSlotVNode", `slot[${t}] is empty`), null;
  const o = i(e(r));
  return o.length === 1 ? o[0] : (n("getFirstSlotVNode", `slot[${t}] should have exactly one child`), null);
}
export {
  d as getFirstSlotVNode
};
